import { waitForMapHydration } from './lib/waitForMapHydration';

// Код карты — отдельный чанк. Один загрузчик и для lazy в секции, и для фоновой докачки
// (app/router/preloadPages): переход на главную внутри сайта не ждёт его по сети
export const loadDeliveryMap = () => import('./DeliveryMap');

// Фоновая докачка не ждёт видимости и не открывает эту границу: сеть и гидратация независимы.
export const loadDeliveryMapWhenVisible = () => {
  const { ready, onHydrated } = waitForMapHydration();
  return { module: ready.then(loadDeliveryMap), onHydrated };
};
